import moment from "moment";
import { getFintoc } from "@fintoc/fintoc-js";

const Swal = require("sweetalert2");

export default {
    data() {
        return {
            autentincacionDosFactores: false,
        };
    },
    methods: {
        mostrarMensajeError(
            mensaje = "Ha ocurrido un problema al procesar el abono"
        ) {
            Swal.fire({
                title: "Notificación",
                text: mensaje,
                icon: "error",
                confirmButtonText: "Cerrar notificación",
                customClass: {
                    confirmButton:
                        "btn boton-pagar btn-lg btn-block button-movired-color",
                },
                buttonsStyling: false,
            }).then(() => {

            });
        },
        async realizarAbonoFintoc(banco) {
            this.$store.commit("comercio/trxComercioBloquearTrue");

            let resGenerarSolicitudAbono = await axios.post(
                "/api/comercio/generar/abono",
                {
                    session_id: this.$store.state.comercio.trxComercio.trx_session_id,
                    origin_bank_id: banco,
                },
                {
                    headers: {
                        Authorization: `Bearer ${this.$store.state.token}`,
                    },
                }
            );

            if (resGenerarSolicitudAbono.data.t_estado == false) {
                this.tokenInvalido();
                return false;
            }

            if (resGenerarSolicitudAbono.data.estado == true) {
                let options = {
                    widgetToken: resGenerarSolicitudAbono.data.widget_token,
                    publicKey: process.env.MIX_APP_TOKEN_FINCTOC,
                    holderType: "individual",
                    product: "payments",
                    country: "cl",
                    webhookUrl:
                        "https://webhook.site/f02c9a93-311c-4955-8928-1e8993cdb691",
                    onSuccess: async () => {
                        //await this.verificarPago(resVerificacionPago.data.widget_token)
                    },
                    onExit: async () => {
                        if (this.autentincacionDosFactores == false) {
                            this.$store.commit("comercio/trxComercioBloquearFalse");
                        }
                    },
                    onEvent: async (eventName, metadata) => {
                        let me = this

                        await axios.post("/api/comercio/trx/log/finctoc", {
                            evento: eventName,
                            timestamps: metadata.timestamp,
                            identificador_banco: banco,
                            session_id: this.$store.state.comercio.trxComercio.trx_session_id,
                            widget_token: resGenerarSolicitudAbono.data.widget_token,
                        });

                        if (eventName == "payment_error") {
                            this.$store.commit("comercio/trxComercioBloquearFalse");
                            this.autentincacionDosFactores = false;
                        }

                        if (
                            eventName == "validating_second_factor" ||
                            eventName == "app_authentication_required"
                        ) {
                            this.autentincacionDosFactores = true;
                        }

                        if (eventName == "closed") {
                            if (this.autentincacionDosFactores == true) {
                                this.verificarPago(
                                    resGenerarSolicitudAbono.data.widget_token
                                );
                            } else {
                                widget.destroy();
                            }
                        }

                        if (eventName == "payment_created") {
                            setTimeout(async function () {
                                widget.close();
                                await me.verificarPago(
                                    resGenerarSolicitudAbono.data.widget_token
                                );
                            }, 3000);
                        }
                    },
                };

                if (banco != null) {
                    options.institutionId = banco;
                }

                const Fintoc = await getFintoc();
                const widget = Fintoc.create(options);
                widget.open();

            } else {
                this.mostrarMensajeError(
                    "Ha ocurrido un error al procesar el pago"
                );
                this.$store.commit("comercio/trxComercioBloquearFalse");
                return false;
            }
        },
        async verificarPago(widget) {
            try {
                if (this.autentincacionDosFactores == false) {
                    this.$store.commit("comercio/trxComercioBloquearFalse");
                }

                let resVerificarPago = await axios.post(
                    "/api/comercio/verificar/pago",
                    {
                        monto: this.$store.state.comercio.trxComercio.trx_monto,
                        session_id: this.$store.state.comercio.trxComercio.trx_session_id,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.state.token}`,
                        },
                    }
                );

                if (resVerificarPago.data.t_estado == false) {
                    this.tokenInvalido();
                    return false;
                }

                if (resVerificarPago.data.estado == true) {
                    this.$store.commit("comercio/trxComercioPagadaTrue");
                    this.$router.push({ name: "comercioTrxExitosa" });
                } else {
                    this.$store.commit("comercio/trxComercioPagadaFalse");
                    this.$router.push({ name: "comercioTrxFallida" });
                }
            } catch (error) {
                // Pago no válido detectado
                //this.$router.push({ name: "estadoPago" });
                console.log(error)
                this.mostrarMensajeError(
                    "Hemos tenido un problema al procesar el pago"
                );
            }
        },
        buscarProducto(productos, identificador) {
            let producto = productos.find(
                (item) => item.producto == identificador
            );

            return producto;
        },
        calculoHoraLink() {
            let minutos = moment().minutes().toString();
            let minuto = minutos.substring(minutos.length - 1);

            let horarios = ["1", "2", "3", "4", "5"];

/*             if (horarios.includes(minuto)) {
                return 1;
            }

            return 2; */

            return 1;
        }
    }

};
